var _style, _polygon, _polygon2, _polygon3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 418.8 118.3",
    style: {
      enableBackground: "new 0 0 418.8 118.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -160.9147,
    y1: -1144.9495,
    x2: -185.7382,
    y2: -1174.5328,
    gradientTransform: "matrix(0.6687 -0.7435 -0.7435 -0.6687 -680.6657 -832.6413)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.38
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04623401,
    style: {
      stopColor: "#2D2D2D",
      stopOpacity: 0.4087
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09866935,
    style: {
      stopColor: "#595959",
      stopOpacity: 0.4412
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1567,
    style: {
      stopColor: "#818181",
      stopOpacity: 0.4771
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2191,
    style: {
      stopColor: "#A3A3A3",
      stopOpacity: 0.5158
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    style: {
      stopColor: "#C0C0C0",
      stopOpacity: 0.558
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3624,
    style: {
      stopColor: "#D7D7D7",
      stopOpacity: 0.6047
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4485,
    style: {
      stopColor: "#E9E9E9",
      stopOpacity: 0.6581
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5516,
    style: {
      stopColor: "#F6F6F6",
      stopOpacity: 0.722
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6889,
    style: {
      stopColor: "#FDFDFD",
      stopOpacity: 0.8071
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "84.7,73.4 50,93.5 50,54.5  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "52,17.8 84.7,37.9 19.4,37.9  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "19.4,37.9 84.7,37.9 84.7,73.4  "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132.9,24.3h11.4v61.4h-11.2v-5.4c-3.6,4.3-8.1,6.5-13.7,6.5c-6.2,0-11.5-2.2-15.6-6.5 c-4.1-4.4-6.2-9.9-6.2-16.6c0-6.5,2.1-12,6.2-16.5c4.2-4.4,9.4-6.6,15.6-6.6c5.3,0,9.8,2.1,13.4,6.2V24.3H132.9z M130.1,54.7 c-2.3-2.5-5.2-3.7-8.8-3.7s-6.5,1.2-8.9,3.7c-2.3,2.4-3.4,5.4-3.4,9c0,3.6,1.1,6.6,3.4,9.1c2.3,2.4,5.3,3.6,8.9,3.6 s6.5-1.2,8.8-3.6c2.3-2.5,3.4-5.5,3.4-9.1S132.3,57.1,130.1,54.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M158.9,47.3c4.4-4.5,10.1-6.8,17-6.8s12.5,2.3,17,6.8c4.4,4.4,6.6,9.9,6.6,16.4s-2.2,12-6.6,16.5 c-4.4,4.4-10.1,6.7-17,6.7s-12.5-2.3-17-6.7c-4.4-4.4-6.6-9.9-6.6-16.5C152.3,57.2,154.5,51.7,158.9,47.3z M175.9,76.3 c3.5,0,6.3-1.2,8.6-3.6c2.3-2.5,3.6-5.5,3.6-9s-1.2-6.5-3.6-8.9c-2.3-2.4-5.2-3.6-8.6-3.6c-3.5,0-6.4,1.2-8.7,3.6 c-2.3,2.4-3.5,5.4-3.5,8.9s1.1,6.5,3.5,9C169.5,75.1,172.4,76.3,175.9,76.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236.4,85.7l-14.5-18.8l-3,2.7v16.2h-11.4V24.3h11.4v32.4l16-15h14.4l-19.6,18l20.8,26 C250.5,85.7,236.4,85.7,236.4,85.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M266,85.7h-11.4V24.3H266V85.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M318.6,67.7h-33.1c1.6,6.2,5.9,9.4,12.8,9.4c4.8,0,10.4-1.9,14.2-4.4l4.5,8c-5.6,4-12,6.1-19.2,6.1 c-7.8,0-13.7-2.3-17.8-6.7c-4.1-4.4-6.1-9.9-6.1-16.3c0-6.7,2.1-12.2,6.4-16.6s9.8-6.5,16.6-6.5c6.4,0,11.7,2,15.8,6 c4.1,4,6.2,9.3,6.2,16.2C319,64.2,318.8,65.9,318.6,67.7z M285.5,59.2h22.4c-1.1-5.7-5.2-9.2-11-9.2 C291.2,50,286.9,53.5,285.5,59.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M323.1,78.4l6.1-7.2c3.2,3.8,7.8,6.1,12.2,6.1c3.5,0,6.1-1.8,6.1-4.3c0-1.5-1-2.8-3.2-3.8 c-0.7-0.3-2.4-1-5.3-2c-2.8-1.1-4.7-1.9-5.7-2.3c-5.1-2.4-7.6-6.2-7.6-11.4c0-3.9,1.5-7,4.5-9.5s7-3.7,12-3.7 c6.2,0,11.4,2.1,15.4,6.3l-5.7,7.4c-3.1-2.9-6.5-4.4-10.1-4.4c-3,0-5,1.7-5,3.7c0,1.9,1.3,3.2,3.9,4c5.8,2.2,9.4,3.6,10.6,4.3 c4.9,2.6,7.4,6.3,7.4,11.2c0,4.1-1.6,7.5-4.8,10.2c-3.2,2.7-7.4,4-12.7,4C333.6,86.9,327.6,84,323.1,78.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M362.6,78.4l6.1-7.2c3.2,3.8,7.8,6.1,12.2,6.1c3.5,0,6.1-1.8,6.1-4.3c0-1.5-1-2.8-3.2-3.8 c-0.7-0.3-2.4-1-5.3-2c-2.8-1.1-4.7-1.9-5.7-2.3c-5.1-2.4-7.6-6.2-7.6-11.4c0-3.9,1.5-7,4.5-9.5s7-3.7,12-3.7 c6.2,0,11.4,2.1,15.4,6.3l-5.7,7.4c-3.1-2.9-6.5-4.4-10.1-4.4c-3,0-5,1.7-5,3.7c0,1.9,1.3,3.2,3.9,4c5.8,2.2,9.4,3.6,10.6,4.3 c4.9,2.6,7.4,6.3,7.4,11.2c0,4.1-1.6,7.5-4.8,10.2c-3.2,2.7-7.4,4-12.7,4C373.1,86.9,367.1,84,362.6,78.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.098de1c4aeb9875508d2b115d2cdd7e7.svg";
export { ForwardRef as ReactComponent };